//法语
module.exports = {
  header1: "Page d'accueil",
  header2: "À propos de nous",
  header2_1: "Qui sommes-nous",
  header2_2: "Pourquoi nous choisir",
  header3: " Plateforme de trading ",
  header4: "Guide MT5",
  header5: " Nous contacter ",
  header6: "Ouvrir un compte réel",
  header7: "Connexion",
  header8: "S'inscrire",
  footer1: "Rejoignez les rangs des commerçants",
  footer2: "Essai gratuit",
  footer3: "Commencer à trader immédiatement",
  footer4: "Suivez-nous",
  footer5: "Droits d'auteur",
  footer6: "Tous droits réservés",
  home1: "Commerce de produits",
  home2: "Les frais de dépôt sont gratuits",
  home3: " aussi faible que la différence de point zéro ",
  home4: "Le commerce peut se faire n'importe où",
  home5: "Plus de 200 produits commercialisables",
  home6: "9 options de période",
  home7: "Vous pouvez vous connecter à votre compte sur Pc et Mobile",
  home8: "Outils d'analyse professionnels",
  home9: "Télécharger MT5 pour PC",
  home10: " commerçant Internet ",
  home11: "Pas besoin de télécharger ou d'installer",
  home12: " Accédez à votre compte sur n'importe quel navigateur Web ",
  home13: "Aussi puissant que MT4",
  home14:
    "Connectez-vous au marché pour des transactions à tout moment, n'importe où",
  home15: "Ouvrir la version web de mt5",
  home16: "Aidez-vous à le faire",
  home17: " Meilleure décision de trading ",
  home18:
    "Utilisez ces outils de trading pour vous aider à prendre la décision la plus éclairée",
  home19: " Système de trading intelligent ",
  home20: " Obtenez des avantages commerciaux grâce à une EA professionnelle ",
  home21: "Signal de trading",
  home22: "Il vous guide vers le succès comme un phare.",
  home23: "Calendrier économique",
  home24: "Maîtriser les dernières tendances du marché",
  home25: "Outil Protrader",
  home26: "Obtenez plus d'opportunités de trading",
  home27: "Nouvelles du marché",
  home28: "Vues du marché sélectionnées",
  home29: " Vue de l'analyste ",
  home30: "Calendrier économique professionnel",
  home31: " Ouvrez un compte de trading et déposez au moins 1 000 USD ",
  home32:
    "Vous pouvez utiliser un ensemble complet d'outils de trading professionnels",
  home33: "Dépôt instantané",
  home34: "Ouvrir un compte réel",
  home35: "Expérience parfaite",
  home36: " Exécution extrêmement rapide des ordres de négociation ",
  home37:
    "'Quels sont les éléments clés lorsque les commerçants choisissent un courtier de change ?' - C'est la question que nous ne cessons de nous poser lors de la création de {plate-forme}. Nous pensons que ces éléments définissent notre valeur et nous permettent de satisfaire nos clients. d'exiger et de continuer à fournir un service excellent et fiable.",
  home38: "Ouverture de compte en 5 minutes",
  home39: " Une combinaison de plus de 200 matières premières échangeables ",
  home40: " Système de gestion de compte entièrement fonctionnel ",
  home41: "Excellente liquidité du marché",
  home42: "En savoir plus",
  home43: " Supervision de la conformité ",
  home44: "Fournir la meilleure sécurité",
  home45:
    " {plateforme} attache une grande importance à la supervision et à la sécurité. Nous offrons à tous nos clients un environnement de trading de devises transparent et sûr. ",
  home46: " Bureau mondial ",
  home47: "Supervision multinationale",
  home48:
    "Coopération avec les plus grandes institutions financières mondiales",
  home49: " Assurance des fonds ",
  home50: "Surveillance",
  home51: "Rémunération",
  home52: "Assurance",
  home53: "Méthode de dépôt",
  home54: " Partenaires de liquidité du marché ",
  home55:
    "{platform} coopère avec plus de 14 des meilleurs fournisseurs de cotations de liquidité au monde, et une liquidité suffisante peut vous fournir les meilleures cotations de trading sur le marché",
  home56: "Commerce de devises",
  home57:
    " Profiter de la crise économique mondiale pour connecter le marché financier le plus liquide au monde ",
  home58: "Commencez à trader immédiatement",
  home59: "Négoce de matières premières en vrac",
  home59_1: "Transaction volumineuse",
  home60:
    " Choisissez l'or, l'argent, le pétrole brut ou d'autres matières premières en fonction du cycle de négociation du marché principal ",
  home61: "Négociation sur indice",
  home61_1: "Index",
  home62:
    "Trade à travers les fluctuations des grands indices boursiers mondiaux tels que SP500, DJ30, FRA40 et DAX30",
  home63: "US/Hong Kong Stock Exchange",
  home64:
    " Maîtriser les tendances des grandes entreprises mondiales et trader les actions américaines et hongkongaises avec des CFD ",
  home65: " Contrat pour la différence ",
  home66: " Entreprise mondiale ",
  home67:
    "C'est notre honneur de fournir aux clients un service de première classe et stable",
  home68: "Commerce de version Web",
  who0: " Qui est {plateforme} ",
  who1: "Rejoignez le courtier le plus innovant",
  who2:
    "{platform} Elle a plus de 10 ans d'expérience et d'expertise sur le marché financier mondial, et s'engage à fournir un accès au marché simple et transparent et à aider les clients atteignent l'objectif financier.",
  who3:
    ` {plateforme} Fondée au Royaume-Uni en 2010, elle a toujours adhéré au concept de "profiter du trading n'importe quand, n'importe où", en utilisant des services techniques avancés pour fournir aux clients une excellente expérience de trading sur le marché des changes, y compris les spreads originaux, les comptes ECN qui exécutent avec précision transactions à grande vitesse et puissant système de gestion des clients, etc.`,
  who4: "Choisissez un courtier de change de confiance",
  who5:
    "{platform1} s'est toujours engagé à fournir aux clients un excellent environnement de trading et a toujours insisté pour dépasser les attentes des régulateurs financiers mondiaux. Dans ce secteur, nous comprenons que les traders sont impatients de trouver une plateforme de confiance. {platform2 }Sous la supervision de plusieurs institutions, nous avons accumulé plus de 10 000 comptes de trading clients actifs dans le monde entier, et ils comptent tous sur {platform3} pour assurer la sécurité de leurs fonds.",
  who6: " Agence de réglementation principale ",
  who6_1: "Réglementation NFA des États-Unis, ID d'enregistrement : 0542569",
  who7: "Nombre global de personnes",
  who8:
    "En tant que l'un des leaders du marché financier mondial, {plate-forme} fournit à nos clients des services stables et de premier ordre.",
  who9: "Voici quelques données pertinentes de {plate-forme} :",
  who10: "10 ans+",
  who11: "Diplômes de l'industrie",
  who12: "Au-dessus de 1,5 milliard de dollars",
  who13: "volume mensuel de transactions",
  who14: "Au-dessus de 7 M",
  who15: " Compte client ",
  who16: "1,5 milliard de dollars",
  who17: " Volume mensuel de transactions ",
  Why0: "Pourquoi choisir {plateforme}",
  Why1: "Pas seulement une plateforme, mais un partenaire",
  Why2:
    "' Que veulent les commerçants lorsqu'ils choisissent un courtier de change ? '-Ce sont les questions que nous nous posions sans cesse lorsque nous avons fondé {platform}. Je pense que ces éléments sont au cœur de nos valeurs, afin que nous puissions répondre aux besoins de nos clients et continuer à fournir des services excellents et fiables.",
  Why3:
    " La chose la plus importante est que nous voulons construire une marque qui soit bien connue au-delà du prix ou du produit. Nous voulons devenir une marque qui est commercialisée dans la nouvelle génération. Connaître les besoins de nos clients nous permet d'apporter des changements plus de flexibilité. Nous sommes une nouvelle marque performante. Plateforme de trading de génération, {plateforme} est toujours à vos côtés quand vous en avez besoin. ",
  Why4: " Nous sommes à vos côtés pendant le voyage commercial ",
  Why5:
    " Que vous soyez un novice ou un vétéran du trading depuis de nombreuses années, notre équipe vous fournira une assistance à tout moment. Notre plateforme est avec vous à tout moment, n'importe où, et notre équipe de service client vous accompagne à chaque étape, nous vous accompagnera pour grandir ensemble. Bien que nos concurrents soient peut-être plus forts que nous, nous avons la volonté d'innover et le soutien d'une plateforme de trading conforme. Découvrez pourquoi {platform} est votre bon choix : ",
  Why6: "Ouvrez un compte réel immédiatement en 5 minutes",
  Why7: " Levier jusqu'à 500 : 1 ",
  Why8: " Plus de 200 types de produits peuvent être échangés ",
  Why9: " Fournir un bonus de trading supplémentaire ",
  Why10: " Puissant système de gestion des clients ",
  Why11: " Excellente liquidité du marché ",
  Why12:
    " Plusieurs organismes de réglementation et des comptes séparés en tant que garantie ",
  trading1: "Utiliser la plateforme Metatrader5",
  trading2: "Trade à tout moment, n'importe où",
  trading3:
    "Si vous êtes un nouveau client de {plate-forme}, remplissez simplement le formulaire en haut de cette page et vous pourrez utiliser la plate-forme de trading MT5 en quelques minutes.",
  trading4:
    "Si vous êtes déjà un client {plateforme} qui négocie sur la plate-forme MT5, il vous suffit de vous connecter à votre expérience de gestion de la clientèle, de cliquer pour ouvrir votre compte et de sélectionner MetaTrader5, vous pouvez passer en toute transparence à MT5 et améliorer davantage votre expérience de trading. ",
  trading5:
    "L'application mobile MT5 vous permet de vous connecter à {plate-forme} à tout moment, n'importe où, et de profiter de services de trading par tous les temps.",
  guide0: "Guide MT5",
  guide1: "Téléchargez MT5 sur votre ordinateur",
  guide3: "Comment insérer un quota de graphique ?",
  guide3_0: "Suivez les étapes ci-dessous :",
  guide3_1:
    "1) Dans la barre de menu supérieure, choisissez d'insérer un quota.",
  guide3_2:
    "2) Vous pouvez également insérer un quota à partir de la section de navigation.",
  guide4: "Comment éviter la protection par pare-feu ?",
  guide4_1:
    "Interdisez à votre pare-feu anti-virus d'appliquer pour MetaTrader 4 et ouvrez le port 1950. Pour MetaTrader 5, ouvrez le port 443.",
  guide5:
    "Comment créer des lignes de tendance et d'autres lignes de recherche ?",
  guide5_1: "1) Dans la colonne du menu du haut, sélectionnez ’Insérer‘",
  guide5_2: "2) Sélectionnez la ligne de tendance souhaitée.",
  guide5_3:
    "3) Après avoir relâché le bouton de la souris, une icône d'image de la ligne de tendance sélectionnée avec un réticule apparaîtra. Utilisez la souris pour placer le réticule sur le graphique sélectionné. Cliquez sur la souris, maintenez enfoncé pour déplacer Utilisez la souris pour ajuster la taille de la ligne de tendance.",
  guide5_4:
    "Le raccourci de la recherche de ligne est également accessible rapidement en cliquant sur la barre d'outils ‘Parcourir’ recherche de ligne, de sorte que l'icône apparaisse juste sous la liste des fonctions.",
  guide5_5:
    "Vous pouvez également choisir d'autres options qui apparaissent en haut de l'écran. Y compris en cliquant sur les lignes de tendance, les réticules, les retracements de Fibonacci, etc.",
  guide6: "Comment afficher le bargraphe ?",
  guide6_1:
    "Dans la barre de menu en haut, sélectionnez ’Chart Bar Graph‘ ou utilisez le raccourci clavier (Alt+1)",
  guide7:
    "Comment obtenir les informations de compte et les transactions quotidiennes sur la plateforme Metatrader?",
  guide7_1:
    "Veuillez utiliser la partie terminal (TERMINAL) de la plateforme. Si vous n'ouvrez pas cette partie, vous pouvez parcourir le terminal TERMINAL ou utiliser le raccourci clavier Cntrl+t.",
  guide7_2:
    "Dans la section du terminal, sélectionnez ’Tag d'historique du compte'.",
  guide7_3:
    "Cette marque vous montre l'historique de votre compte. Il peut également être imprimé pour votre commodité.",
  guide7_4:
    "Cliquez avec le bouton droit de la souris n'importe où dans cette section.",
  guide7_5:
    "Sélectionnez 'Enregistrer comme rapport'. (Il peut également être enregistré sous forme de fichier HTML, qui peut être converti en un fichier Excel pour l'enregistrement.)",
  guide8: "Comment afficher le graphique en chandeliers ?",
  guide8_1:
    ' Dans la barre de menu supérieure, sélectionnez " Chart Chandelier " ou utilisez le raccourci clavier (Alt+2). ',
  guide9:
    "Puis-je utiliser l'interface de l'application MetaTrader sur votre système ? Cela peut-il être fait d'abord sur le compte mini/analogique ?",
  guide9_1:
    " Oui, aussi longtemps que vous le souhaitez, vous pouvez d'abord utiliser le compte analogique. Généralement, des termes et conditions spécifiques s'appliquent à l'interface de l'application pour accéder au système réel. Veuillez vous assurer de discuter de votre projet avec un représentant FXDD, afin que , Ils peuvent vous aider.",
  guide10: "Comment afficher le graphique linéaire ?",
  guide10_1:
    'Dans la barre de menu supérieure, sélectionnez "Graphique linéaire" ou utilisez le raccourci clavier (Alt+3).',
  guide11: "Comment zoomer ou dézoomer le graphique ?",
  guide11_1: "1) Assurez-vous que la barre d'outils 'Graphique' est activée",
  guide11_2:
    "2) Ensuite, sélectionnez l'icône de l'action raisonnable située sous la liste des fonctions, à savoir '+' et '-'.",
  guide11_3:
    "3) Sélectionnez l'une des deux icônes pour effectuer un zoom avant ou arrière.",
  guide11_4:
    "Ou, utilisez le raccourci clavier pour cette fonction. Le zoom avant est (Maj +), et le zoom arrière est (-).",
  guide12: " La plateforme MetaTrader aide-t-elle au trading mini-main (10K) ?",
  guide12_1:
    "Oui, vous pouvez utiliser la plateforme MetaTrader pour trader des mini lots (10K).",
  guide12_2:
    "Ce qui suit est la gamme de tailles de lots que nous utilisons pour le trading sur Metatrader :",
  guide12_3:
    "0,01 lot = 1000 devise de base de l'organisation (ou dollar américain) notre 'super mini' lot.",
  guide12_4:
    "0.10 lot = 10000 devise de base de l'organisation (ou dollar américain) notre 'mini' lot.",
  guide12_5:
    "1.00 lot=100000 notre lot 'standard' de la devise de base de l'organisation (ou dollar américain).",
  guide13:
    " J'ai téléchargé la plateforme. Comment puis-je me connecter à mon compte réel pour trader ? ",
  guide13_1:
    "L'utilisateur doit avoir reçu une notification par e-mail d'approbation de compte. Le nom de connexion et le mot de passe sont indiqués sur la notification (c'est-à-dire que le nom de connexion est '81234' et le mot de passe est 'xxxxx'). Il s'agit des informations de compte de votre compte réel. Si vous avez téléchargé la plateforme et ouvert l'écran de connexion. Notez que l'écran qui s'ouvre à ce moment vous demandera d'ouvrir un compte. Vous pouvez cliquer sur 'X' pour quitter cet écran.",
  guide13_2:
    "Lors de la connexion, sélectionnez 'Fichier de connexion' et saisissez votre nom de connexion et votre mot de passe.",
  guide13_3:
    "Le champ du serveur a un menu déroulant, sélectionnez le serveur suivant : ‘FXDD-MT5 Live Server 2-FXDD’.",
  guide13_4:
    "Écoutez le son 'ding' (tonalité de confirmation), votre compte apparaîtra dans le coin supérieur gauche de la plateforme.",
  guide13_5:
    " Si vous voyez le prix évoluer dans le Market Watch et que le solde correct s'affiche sur la partie terminal, cela indique que vous vous êtes connecté avec succès à votre compte réel. Si vous rencontrez des problèmes pour vous connecter, veuillez envoyer un e-mail à info support@leedword.com.",
  guide14: "Comment changer mon mot de passe sur MetaTrader ?",
  guide14_1:
    " Dans la barre de menu supérieure, sélectionnez ' Options des outils ' ou le raccourci clavier (Ctrl+O). ",
  guide14_2: "Sous l'icône 'Serveur', sélectionnez 'Modifier'.",
  guide14_3:
    "Entrez le mot de passe actuel dans le champ de texte 'Mot de passe actuel'.",
  guide14_4: " Cochez la case ' Modifier le mot de passe principal '. ",
  guide14_5:
    "Entrez le nouveau mot de passe dans le champ de texte 'Nouveau mot de passe'.",
  guide14_6:
    "Retapez le nouveau mot de passe dans le deuxième champ de texte 'Confirmer'.",
  guide15: "Comment choisir une langue ?",
  guide15_1:
    "Sur la barre de menu du haut, sélectionnez 'Parcourir la langue', choisissez votre langue préférée. Fermez ensuite la plateforme et redémarrez le programme.",
  guide16:
    "Pour afficher différentes fenêtres sur la plateforme, quels raccourcis clavier peuvent être utilisés ?",
  guide16_1: " Les raccourcis clavier les plus couramment utilisés sont : ",
  guide16_2: "Ctrl+M=fenêtre d'observation des prix du marché",
  guide16_3: "Ctrl+N=Fenêtre de navigation",
  guide16_4: "Ctrl+T=Fenêtre terminal",
  guide17:
    "Comment puis-je voir toutes les paires de devises fournies par FXDD ?",
  guide17_1:
    "Dans la fenêtre Market Watch, cliquez avec le bouton droit de la souris et sélectionnez 'Afficher tout' pour afficher toutes les paires de devises pouvant être échangées. Toutes les paires de devises peuvent être affichées à tout moment. ",
  guide18:
    " Comment afficher les prix hauts/bas dans la fenêtre Market Watch ? ",
  guide18_1:
    "Dans la fenêtre Market Watch, suivez les étapes ci-dessous pour afficher les prix haut/bas :",
  guide18_2:
    "Clic droit (n'importe quelle partie) dans la fenêtre Market Watch",
  guide18_3:
    " Sélectionnez ' Élevé '/' Bas '. (À ce moment, les prix haut et bas de chaque paire de devises du jour apparaîtront.)",
  guide19:
    " Pouvez-vous guider la création de graphiques ? Quelles sont les options ? ",
  guide19_1:
    "Oui, la plateforme MetaTrader 5 est l'une des plateformes les plus avancées du marché, en particulier les options graphiques et les packages.",
  guide19_2:
    " Utilisez l'option ' Sujets d'aide '  dans le menu Aide (appuyez sur F1) et cochez la section ' Commencez à travailler avec le graphique '. Cette section doit être utilisée comme un bon début. ",
  guide19_3:
    "Vous pouvez modifier l'apparence générale du graphique ('Liste des fonctions" -
    "Graphique'-'Contenu'). Vous pouvez modifier la couleur de l'arrière-plan, du premier plan, du tableau, etc. Vous pouvez faire défiler le bord du fenêtre graphique pour ajuster la taille du graphique, et appuyez sur le bouton de la souris pour redimensionner.",
  guide20:
    "Comment modifier la période d'affichage des graphiques MetaTrader ?",
  guide20_1:
    " Lorsque vous ajoutez une limite de temps à la barre de menu principale, sélectionnez ' Parcourir la barre d'outils '. ' Période ' (si nécessaire). Utilisez la légende suivante pour utiliser la limite de temps dans le graphique : ",
  guide20_2: "M1=1 carte minute",
  guide20_3: "M5=graphique 5 minutes",
  guide20_4: "M15=carte 15 minutes",
  guide20_5: "M30=carte 30 minutes",
  guide20_6: "H1=1 graphique horaire",
  guide20_7: "H4=graphique 4 heures",
  guide20_8: "D1=Graphique journalier",
  guide20_9: "W1=Graphique hebdomadaire",
  guide20_10: "MN=Graphique mensuel",
  guide21: " Existe-t-il un guide de l'utilisateur pour MetaTrader 5 ? ",
  guide21_1:
    "Oui, sélectionnez 'Help Topics' sur la plateforme ou vous pouvez cliquer ici pour télécharger. Veuillez noter que nous avons des séminaires en ligne qui peuvent vous aider à comprendre les fonctions de cette plateforme. Si vous souhaitez participer à ces séminaires en ligne Oui, veuillez envoyer un e-mail au service commercial.",
  guide22:
    "Quel est le fuseau horaire sur la plateforme Metatrader ? Cette heure peut-elle être ajustée ?",
  guide22_1:
    " En été, l'heure du client sur MetaTrader est GMT+3 (heure de Greenwich plus 3 heures, heure de Pékin plus 5 heures). Malheureusement, l'heure sur la plateforme MetaTrader ne peut pas être modifiée. Désolé pour le désagrément.",
  guide23:
    "Comment ouvrir un autre compte analogique sur la plateforme MetaTrader ?",
  guide23_1: "Sélectionnez 'Fichier pour ouvrir un compte' dans la plateforme",
  guide23_2:
    "Remplissez les informations demandées (assurez-vous de cocher la colonne 'J'accepte de m'abonner à votre newsletter')",
  guide23_3: "Choisissez 'Suivant' (sur la page du serveur)",
  guide23_4:
    "Choisissez 'Suivant' (Veuillez noter que votre nom d'utilisateur et votre mot de passe apparaîtront)",
  guide23_5: "Sélectionnez 'Terminer'",
  guide23_6:
    "Ce logiciel vous connectera automatiquement à votre nouveau compte analogique et le visualisera dans la fenêtre de navigation.",
  guide24:
    " Quels sont les facteurs qui affectent la quantité de communication dans le programme ? ",
  guide24_1:
    " La quantité de communication de sortie dépend de l'activité de l'utilisateur, et la quantité est assez petite. La quantité de communication d'entrée dépend directement du nombre de fenêtres graphiques ouvertes. ",
  guide25: "Puis-je recevoir des avertissements par e-mail ?",
  guide25_1:
    "Suivez les étapes ci-dessous pour créer une alerte email dans MetaTrader 5:",
  guide25_2:
    "(Tous les paramètres SMTP (Simple Mail Transfer Protocol) varient selon le fournisseur de services Internet. Si vous recevez un message d'erreur, contactez le support technique de votre fournisseur de services Internet et demandez-lui d'implémenter le protocole Simple Mail Transfer Protocol Si vous utilisez Outlook, vous pouvez sélectionnez 'Outils modification du compte de messagerie étape suivante' pour annuler une fois terminé) pour définir le protocole de transfert de courrier simple.",
  guide25_3: "Sélectionnez 'Options d'outils'.",
  guide25_4: "Sélectionnez l'icône 'Email'.",
  guide25_5:
    " Modifiez les paramètres ci-dessus en fonction des exigences de votre fournisseur de services Internet. Généralement, le texte en rouge clair est la directive générale que vous devez vous connecter. Veuillez contacter votre fournisseur de services Internet pour obtenir des instructions spécifiques. (Remarque : les services de messagerie Web non disponibles incluent Hotmail, Yahoo, Gmail, etc.)",
  guide25_6:
    " Simple Mail Transfer Protocol Server-Il s'agit de l'adresse du serveur de messagerie de votre fournisseur de services Internet ",
  contact1: "Quand vous avez besoin de nous, nous sommes toujours à vos côtés",
  contact2:
    "Si vous avez des questions ou avez besoin de plus d'aide, veuillez nous contacter via les méthodes de contact suivantes. Nous ferons de notre mieux pour répondre à toutes les questions dès que possible.",
  contact3: "Adresse enregistrée",
  contact4: " Bureau des Caïmans ",
  contact5: " Bureau de Taipei ",
  contact6: " No. 7, Section 5, District de Xinyi, Taipei, Taiwan (Taipei 101)",
  contact7: "Adresse e-mail",
  contact8: "Téléphoner",
  adresse1: "Australie, Sydney",
  adresse2: "Taipei",
  adresse3: "Thaïlande, Bangkok",
  adresse4: " Malaisie, Kuala Lumpur ",
  adresse5: " Royaume-Uni, Londres ",
  adresse6: "États-Unis, New York",
  address7: "Singapour, Singapore City",
  adresse8: " Îles Caïmans, George Town ",
  adresse9: "Chypre, Nicosie",
  adresse10: "Hong Kong",
  adresse11: "Vietnam, Hanoï",
  adresse12: "Australie, Melbourne"
};



// WEBPACK FOOTER //
// ./src/common/lang/fr.js